export default __webpack_public_path__ + "static/media/ryan.7990a5da.jpg";